<template>
    <div>
      <section id="page-title">
            <div class="container clearfix">
                <h1 data-animate="fadeInUp">2014 Summer</h1>
                <span data-animate="fadeInUp" data-delay="300">Cinderella</span>
            </div>
        </section>
        <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div class="portfolio-masonry clearfix" id="portfolio">
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/1june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/1june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/2june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/2june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/3june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/3june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/4june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/4june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/5june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/5june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/6june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/6june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/7june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/7june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/8june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/8june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/9june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/9june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/10june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/10june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/11june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/11june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/12june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/12june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img alt="Summer 2014 IDS" src="/assets/img/2014-june/thumbs/13june2013.jpg" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a class="center-icon" data-lightbox="image" href="/assets/img/2014-june/13june2013.jpg"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>


                        <!--Winter 2014 end-->
                        <!-- Portfolio Script
============================================= -->
                       <!-- <script type="text/javascript">
                            jQuery(window).load(function() {

                                var $container = $('#portfolio');

                                $container.isotope({
                                    transitionDuration: '0.65s'
                                });

                                $('#portfolio-filter a').click(function() {
                                    $('#portfolio-filter li').removeClass('activeFilter');
                                    $(this).parent('li').addClass('activeFilter');
                                    var selector = $(this).attr('data-filter');
                                    $container.isotope({
                                        filter: selector
                                    });
                                    return false;
                                });

                                $('#portfolio-shuffle').click(function() {
                                    $container.isotope('updateSortData').isotope({
                                        sortBy: 'random'
                                    });
                                });

                                $(window).resize(function() {
                                    $container.isotope('layout');
                                });

                            });
                        </script>-->
                        <!-- Portfolio Script End -->
                    </div>
                </div>
            </div>
        </section>
        <!-- #content end -->
    </div>
</template>
<script>
  export default {
    name: "20142spring", 
    components: {

    },
    mounted(){
        jQuery(window).load(function() {

        var $container = jQuery('#portfolio');

        $container.isotope({
            transitionDuration: '0.65s'
        });

        jQuery('#portfolio-filter a').click(function() {
            jQuery('#portfolio-filter li').removeClass('activeFilter');
            jQuery(this).parent('li').addClass('activeFilter');
            var selector = $(this).attr('data-filter');
            $container.isotope({
                filter: selector
            });
            return false;
        });

        jQuery('#portfolio-shuffle').click(function() {
            $container.isotope('updateSortData').isotope({
                sortBy: 'random'
            });
        });

        jQuery(window).resize(function() {
            $container.isotope('layout');
        });

    });
    }
  }
</script>
